import { render, staticRenderFns } from "./CourseEnrollStep2Page.vue?vue&type=template&id=3eb5d0ba"
import script from "./CourseEnrollStep2Page.vue?vue&type=script&lang=js"
export * from "./CourseEnrollStep2Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports